// extracted by mini-css-extract-plugin
export default {"container":"Products_container__Sfmko","products":"Products_products__VXAqB","menu":"Products_menu__fcAb4","list":"Products_list__rFVC2","product":"Products_product__1NJEt"};